import {
  Typography,
  Stack,
  Collapse,
  IconButton
} from "@mui/material";
import { CheckCircle, ErrorOutline, Sync, KeyboardArrowRight } from "@mui/icons-material";
import { customerCareSchema, ICustomerCareFormValues } from "@/utils/zod/generalSettingsFormValidation";
import { useForm } from "@refinedev/react-hook-form";
import { FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { AutoSaveIndicator } from "@refinedev/mui";
import { useState } from "react";
import { useList } from "@refinedev/core";
import RHFAutoCompleteString from "@/components/form/RHFAutocompleteString";
const CustomerCareSection = ({values}: {values: ICustomerCareFormValues}) => {

  const methods = useForm<ICustomerCareFormValues>({
    refineCoreProps: {
      action: "edit",
      resource: "general-settings",
      id: "customer-care-phone-number",
      queryOptions: {
        enabled: false,
      },
      autoSave: {
        enabled: true,
        debounce: 2000,
        onFinish: (values) => {
          if (values.customer_care_phone_number.replace(/\D/g, '').length !== 10) {
            methods.setError("customer_care_phone_number", {
              type: "manual",
              message: "Please enter a valid 10-digit phone number"
            });
            return Promise.reject(new Error("Invalid phone number, skipping auto-save."));
          } else {
            methods.clearErrors("customer_care_phone_number");
          }
          return {
            customer_care_phone_number: values.customer_care_phone_number
          }
        }
      }
    },
    resolver: zodResolver(customerCareSchema),
    defaultValues: {
        customer_care_phone_number: values.customer_care_phone_number || ""
    },
    values: values
  });

  const { refineCore: { autoSaveProps } } = methods;

  const [isExpanded, setIsExpanded] = useState(true);

  const { data: teamMembers } = useList({
    resource: "accounts/team-members",
  });

  return (
    <FormProvider {...methods}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            <KeyboardArrowRight
              sx={{
                color: 'primary.main',
                fontSize: '2rem',
                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s'
              }}
            />
          </IconButton>
          <Typography variant="h6" gutterBottom>
            Customer Care Phone Number
          </Typography>
          {isExpanded && <AutoSaveIndicator {...autoSaveProps} elements={{
            success: <Typography variant="body1" sx={{ color: 'success.main', display: 'flex', alignItems: 'center', gap: 1 }}><CheckCircle /> Saved</Typography>,
            error: <Typography variant="body1" sx={{ color: 'error.main', display: 'flex', alignItems: 'center', gap: 1 }}><ErrorOutline /> Error</Typography>,
            loading: <Typography variant="body1" sx={{ color: 'warning.main', display: 'flex', alignItems: 'center', gap: 1 }}><Sync /> Saving...</Typography>,
            idle: <Typography variant="body1" sx={{ color: 'grey.500', display: 'flex', alignItems: 'center', gap: 1 }}>Waiting for changes ...</Typography>
          }} />}
        </Stack>
        <Collapse in={isExpanded} sx={{ paddingLeft: '2rem' }}>
          <RHFAutoCompleteString
            name="customer_care_phone_number"
            label=""
            options={(teamMembers?.data ?? [])?.map((member) => member.user?.phone_number.toString().startsWith('91') ? member.user?.phone_number.toString().slice(2) : null) ?? []}
            multiple={false}
            sx={{ flex: 1 }}
            createNew={false}
            required
            size="small"
        />
        </Collapse>
    </FormProvider>
  );
};

export default CustomerCareSection; 